// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-fluid {
  padding-right: 0;
  padding-left: 0;
  position: absolute;
  height: 100%;
}
.container-fluid .row {
  height: 100%;
}
.container-fluid .header-container {
  background-color: var(--headerBackground);
  color: var(--textColorPrimary);
  transition: 0.1s background-color ease-in;
  transition: 0.1s color ease-in;
}
.container-fluid .header-container .header-fixed {
  padding: 2rem;
  max-width: inherit;
  height: 100%;
}
@media (min-width: 992px) {
  .container-fluid .header-container .header-fixed {
    position: fixed;
  }
}
.container-fluid .header-container .logo img {
  display: block;
  margin: 0 auto;
  width: 100%;
}
@media (max-width: 991.98px) {
  .container-fluid .header-container .logo img {
    max-width: 200px;
  }
}
.container-fluid .header-container .name-title {
  font-family: "Montserrat", sans-serif;
  padding-top: 2rem;
}
.container-fluid .header-container .name-title h1, .container-fluid .header-container .name-title h3 {
  text-align: center;
}
.container-fluid .header-container .name-title h1 {
  font-size: 3rem;
}
.container-fluid .header-container .name-title h3 {
  font-family: "PT Sans", sans-serif;
  font-size: 1.5rem;
}
.container-fluid .header-container .footer {
  position: absolute;
  bottom: 20px;
}
.container-fluid .header-container .footer a, .container-fluid .header-container .footer span {
  color: var(--textColorPrimary);
  font-size: 30px;
  transition: 0.3s text-shadow ease-in;
  margin-right: 10px;
  transition: 0.1s color ease-in;
  cursor: pointer;
}
.container-fluid .header-container .footer a:last-child, .container-fluid .header-container .footer span:last-child {
  margin-right: 0px;
}
.container-fluid .header-container .footer a:hover, .container-fluid .header-container .footer span:hover {
  text-decoration: none;
  text-shadow: 0px 0px 15px var(--textHoverHighlight);
}
.container-fluid .header-container .footer a span.hidden, .container-fluid .header-container .footer span span.hidden {
  display: none;
}
@media (max-width: 991.98px) {
  .container-fluid .header-container .footer {
    position: relative;
    bottom: 0;
  }
}
.container-fluid .body-container {
  background-color: var(--bodyBackground);
  color: var(--textColorSecondary);
  padding: 1rem;
  transition: 0.1s background-color ease-in;
  transition: 0.1s color ease-in;
}
@media (min-width: 992px) {
  .container-fluid .body-container {
    padding: 2rem;
  }
  .container-fluid .body-container .col-lg-6 {
    padding: 1rem;
  }
}
.container-fluid .body-container .info-container {
  margin-bottom: 20px;
}
.container-fluid .body-container .info-container:last-child {
  margin-bottom: 0px;
}
.container-fluid .body-container .info-container .info-header {
  margin-bottom: 10px;
}
.container-fluid .body-container .info-container .info-header span {
  text-transform: uppercase;
  font-size: 1.5rem;
  color: var(--textColorPrimary);
  text-shadow: 1px 1px 10px var(--headerBackground);
  border-bottom: 3px solid var(--colorHighlight);
  transition: 0.1s color ease-in;
}
.container-fluid .body-container .prev-work .proj-container {
  margin-bottom: 15px;
}
.container-fluid .body-container .prev-work .proj-container .proj-title {
  color: var(--textColorPrimary);
  transition: 0.3s text-shadow ease-in;
  padding-right: 10px;
  transition: 0.1s color ease-in;
}
.container-fluid .body-container .prev-work .proj-container .proj-title:hover {
  text-decoration: none;
  text-shadow: 0px 0px 15px var(--textHoverHighlight);
  transition: 0.1s text-shadow ease-in;
}
.container-fluid .body-container .prev-work .proj-container .proj-title .la-external-link {
  color: #007bff;
  font-size: 12px;
  vertical-align: super;
  transition: 0.1s color ease-in;
}
.container-fluid .body-container .prev-work .proj-container .proj-year {
  font-size: 80%;
  color: var(--textColorDark);
  vertical-align: text-top;
  padding-left: 10px;
  border-left: 2px solid var(--colorHighlight);
  transition: 0.1s color ease-in;
}
.container-fluid .body-container .prev-work .proj-container .la-angle-left, .container-fluid .body-container .prev-work .proj-container .la-angle-down {
  margin-left: 10px;
  cursor: pointer;
}
.container-fluid .body-container .prev-work .proj-container .proj-short {
  font-size: 80%;
  overflow: hidden;
}
.container-fluid .body-container .development-skills .info-body > span, .container-fluid .body-container .todo .info-body > span {
  display: block;
  font-size: 90%;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AACF;AACE;EACE,YAAA;AACJ;AAEE;EACE,yCAAA;EACA,8BAAA;EACA,yCAAA;EACA,8BAAA;AAAJ;AAEI;EACE,aAAA;EACA,kBAAA;EACA,YAAA;AAAN;AACM;EAJF;IAKI,eAAA;EAEN;AACF;AACI;EACE,cAAA;EACA,cAAA;EACA,WAAA;AACN;AAEI;EACE;IACE,gBAAA;EAAN;AACF;AAGI;EACE,qCAAA;EACA,iBAAA;AADN;AAGM;EACE,kBAAA;AADR;AAIM;EACE,eAAA;AAFR;AAKM;EACE,kCAAA;EACA,iBAAA;AAHR;AAOI;EACE,kBAAA;EACA,YAAA;AALN;AAOM;EACE,8BAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;AALR;AAOQ;EACE,iBAAA;AALV;AAQQ;EACE,qBAAA;EACA,mDAAA;AANV;AASQ;EACE,aAAA;AAPV;AAYI;EACE;IACE,kBAAA;IACA,SAAA;EAVN;AACF;AAcE;EACE,uCAAA;EACA,gCAAA;EACA,aAAA;EACA,yCAAA;EACA,8BAAA;AAZJ;AAcI;EAPF;IAQI,aAAA;EAXJ;EAaI;IACE,aAAA;EAXN;AACF;AAcI;EACE,mBAAA;AAZN;AAcM;EACE,kBAAA;AAZR;AAeM;EACE,mBAAA;AAbR;AAeQ;EACE,yBAAA;EACA,iBAAA;EACA,8BAAA;EACA,iDAAA;EACA,8CAAA;EACA,8BAAA;AAbV;AAkBI;EACE,mBAAA;AAhBN;AAkBM;EACE,8BAAA;EACA,oCAAA;EACA,mBAAA;EACA,8BAAA;AAhBR;AAkBQ;EACE,qBAAA;EACA,mDAAA;EACA,oCAAA;AAhBV;AAmBQ;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,8BAAA;AAjBV;AAqBM;EACE,cAAA;EACA,2BAAA;EACA,wBAAA;EACA,kBAAA;EACA,4CAAA;EACA,8BAAA;AAnBR;AAsBM;EACE,iBAAA;EACA,eAAA;AApBR;AAuBM;EACE,cAAA;EACA,gBAAA;AArBR;AAyBI;EACE,cAAA;EACA,cAAA;AAvBN","sourcesContent":[".container-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  position: absolute;\n  height: 100%;\n\n  .row {\n    height: 100%;\n  }\n\n  .header-container {\n    background-color: var(--headerBackground);\n    color: var(--textColorPrimary);\n    transition: 0.1s background-color ease-in;\n    transition: 0.1s color ease-in;\n\n    .header-fixed {\n      padding: 2rem;\n      max-width: inherit;\n      height: 100%;\n      @media (min-width: 992px) {\n        position: fixed;\n      }\n    }\n\n    .logo img {\n      display: block;\n      margin: 0 auto;\n      width: 100%;\n    }\n\n    @media (max-width: 991.98px) {\n      .logo img {\n        max-width: 200px;\n      }\n    }\n\n    .name-title {\n      font-family: 'Montserrat', sans-serif;\n      padding-top: 2rem;\n\n      h1, h3 {\n        text-align: center;\n      }\n\n      h1 {\n        font-size: 3rem;\n      }\n\n      h3 {\n        font-family: 'PT Sans', sans-serif;\n        font-size: 1.5rem;\n      }\n    }\n\n    .footer {\n      position: absolute;\n      bottom: 20px;\n\n      a, span {\n        color: var(--textColorPrimary);\n        font-size: 30px;\n        transition: 0.3s text-shadow ease-in;\n        margin-right: 10px;\n        transition: 0.1s color ease-in;\n        cursor: pointer;\n\n        &:last-child {\n          margin-right: 0px;\n        }\n\n        &:hover {\n          text-decoration: none;\n          text-shadow: 0px 0px 15px var(--textHoverHighlight);\n        }\n\n        span.hidden {\n          display: none;\n        }\n      }\n    }\n\n    @media (max-width: 991.98px) {\n      .footer {\n        position: relative;\n        bottom: 0;\n      }\n    }\n  }\n\n  .body-container {\n    background-color: var(--bodyBackground);\n    color: var(--textColorSecondary);\n    padding: 1rem;\n    transition: 0.1s background-color ease-in;\n    transition: 0.1s color ease-in;\n\n    @media (min-width: 992px) {\n      padding: 2rem;\n\n      .col-lg-6 {\n        padding: 1rem;\n      }\n    }\n\n    .info-container {\n      margin-bottom: 20px;\n\n      &:last-child {\n        margin-bottom: 0px;\n      }\n\n      .info-header {\n        margin-bottom: 10px;\n\n        span {\n          text-transform: uppercase;\n          font-size: 1.5rem;\n          color: var(--textColorPrimary);\n          text-shadow: 1px 1px 10px var(--headerBackground);\n          border-bottom: 3px solid var(--colorHighlight);\n          transition: 0.1s color ease-in;\n        }\n      }\n    }\n\n    .prev-work .proj-container {\n      margin-bottom: 15px;\n\n      .proj-title {\n        color: var(--textColorPrimary);\n        transition: 0.3s text-shadow ease-in;\n        padding-right: 10px;\n        transition: 0.1s color ease-in;\n\n        &:hover {\n          text-decoration: none;\n          text-shadow: 0px 0px 15px var(--textHoverHighlight);\n          transition: 0.1s text-shadow ease-in;\n        }\n\n        .la-external-link {\n          color: #007bff;\n          font-size: 12px;\n          vertical-align: super;\n          transition: 0.1s color ease-in;\n        }\n      }\n\n      .proj-year {\n        font-size: 80%;\n        color: var(--textColorDark);\n        vertical-align: text-top;\n        padding-left: 10px;\n        border-left: 2px solid var(--colorHighlight);\n        transition: 0.1s color ease-in;\n      }\n\n      .la-angle-left, .la-angle-down {\n        margin-left: 10px;\n        cursor: pointer;\n      }\n\n      .proj-short {\n        font-size: 80%;\n        overflow: hidden;\n      }\n    }\n\n    .development-skills .info-body > span, .todo .info-body > span {\n      display: block;\n      font-size: 90%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
